import { render, staticRenderFns } from "./LuminanceMask.vue?vue&type=template&id=5aab70c4&"
import script from "./LuminanceMask.vue?vue&type=script&lang=js&"
export * from "./LuminanceMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports